import * as GlobalScope from '/home/circleci/app/docs-www/src/globalReferences.js';
          export const Scope = GlobalScope;
          /**
 * CAUTION: Do not delete this file.
 * In build process there will be added imports to user defined global references
 */
